export default "/images/plus.svg?887d2aad484110b1f963a4231aa8b89d";